import axios, { AxiosResponse } from "axios";
import { message } from "ant-design-vue";
import { HttpService } from "@/core";
import { ResponseResp } from "@/core/interface";
import { Ref, ref } from "vue";
import { SignReq, SignResp, StsAccount } from "./file-upload.interface";
import { random_string } from "@/utils";
//公有权限
const PUBLIC_URL = "/v1/oss/sign";
//私有权限
const PRIVATE_URL = "/v1/oss/signPartnerOne";

interface IUrls {
  url: string;
  key: string;
}
export class FileUploadService {
  /**
   * 获取上传签名
   */
  static async fetchSign(params: SignReq): Promise<any> {
    let sign;
    try {
      // const r: AxiosResponse<ResponseResp<any>> = await HttpService.axios({
      //   method: "GET",
      //   url: params.path,
      //   params,
      // });

      // const res = r.data;

      const r: AxiosResponse<ResponseResp<any>> = await axios.get(
        "https://fstorage." +
          process.env.VUE_APP_ENV_TAG +
          "homedo.com/tools/tools-service/oss/getOssSignatureByBusinessTag?businessTag=homedo-sass"
      );
      const res = r.data;
      console.log(
        "🚀 ~ file: file-upload.service.ts:21 ~ FileUploadService ~ fetchSign ~ res:",
        res
      );
      if (res.respCode !== "0000") {
        message.error(res.respDesc);
      } else {
        sign = {
          ...res.data,
          OSSAccessKeyId: res.data.accesskey,
          callback: "",
          dir: "",
          expire: "",
          host: res.data.host,
          key: res.data.key,
          ossaccessKeyId: res.data.accesskey,
          policy: res.data.policy,
          signature: res.data.signature,
        };
        console.log(
          "🚀 ~ file: file-upload.service.ts:46 ~ FileUploadService ~ fetchSign ~ sign:",
          sign
        );
      }
    } catch (e: any) {
      message.error(e.message);
    }
    return sign;
  }
  static async generateSignUrl(keys) {
    let url;
    try {
      const r: AxiosResponse<ResponseResp<SignResp>> = await HttpService.axios({
        method: "post",
        url: "/v1/oss/get",
        data: keys,
      });
      const res = r.data;
      if (res.respCode !== "0000") {
        message.error(res.respDesc);
      } else {
        url = res.data;
      }
    } catch (e: any) {
      message.error(e.message);
    }
    return url;
  }
  static async uploadFileToOss(file, path, loading = ref(false)) {
    let url = "";
    const signReq = new SignReq();
    signReq.merge({ dir: "cpms", fileName: file.name, path });
    const sign = await FileUploadService.fetchSign(signReq);

    if (!sign) {
      return url;
    }
    const key = sign.dir || "";
    let name = sign.dir || "";

    if (file.name !== "") {
      const splitName = file.name.split(".");
      const len = splitName.length;
      const suffix = len > 1 ? splitName[len - 1] : "";
      name =
        sign.key +
        "_" +
        (key === "" ? `${random_string()}.${suffix}` : `${key}/${random_string()}.${suffix}`);
    }
    try {
      const fd = new FormData();
      fd.append("key", name);
      fd.append("policy", sign.policy);
      fd.append("OSSAccessKeyId", sign.OSSAccessKeyId);
      fd.append("success_action_status", "200");
      fd.append("signature", sign.signature);
      // fd.append("file", file, file.name);
      fd.append("Filename", name.replace(`${sign.dir}/`, ""));
      fd.append("file", file, name.replace(`${sign.dir}/`, ""));
      console.log(
        "🚀 ~ file: file-upload.service.ts:113 ~ FileUploadService ~ uploadFileToOss ~ fd:",
        fd,
        sign
      );
      if (loading) {
        (loading as Ref).value = true;
      }
      // await HttpService.axios({
      //   method: "POST",
      //   url: sign.host,
      //   data: fd,
      // });
      var oReq = new XMLHttpRequest();
      oReq.open("POST", sign.host, false); // 同步请求
      oReq.onload = () => {
        // paths.push({
        //   url: `${data.host}/${name}`,
        //   name: name.replace(`${data.dir}/`, ''),
        //   originalName: file.name,
        //   sources: 1
        // })
        // callback(i)
      };
      oReq.send(fd);
      if (loading) {
        (loading as Ref).value = false;
      }
      url = `${sign.host}/${name}`;
    } catch (e: any) {
      if (loading) {
        (loading as Ref).value = false;
      }
      message.error("附件上传失败");
    }
    if (path === PRIVATE_URL) {
      let key = name;
      let urls = await FileUploadService.generateSignUrl([key]);
      return { url: urls.expirationUrl[key], key };
    } else if (path === PUBLIC_URL) {
      return url;
    }
  }
  //上传到私有权限oss
  static async uploadToPrivateOss(file): Promise<IUrls> {
    //@ts-ignore
    return FileUploadService.uploadFileToOss(file, PRIVATE_URL);
  }
  /**
   * 上传文件到公有权限阿里云OSS
   */
  static async uploadToOss(file, loading = ref(false)): Promise<string> {
    //@ts-ignore
    return FileUploadService.uploadFileToOss(file, PUBLIC_URL, loading);
  }

  static fetchSts() {
    const api = () =>
      HttpService.axios({
        method: "GET",
        url: "/v1/oss/sts/account",
      });
    return HttpService.useRequest<StsAccount>(api);
  }
  static async fetchSts2() {
    const r = await axios.post(
      "https://fstorage." +
        process.env.VUE_APP_ENV_TAG +
        "homedo.com/tools/tools-service/oss/stsNew",
      {
        request: {
          businessTag: "hmd-partner-one",
        },
      }
    );
    const res = r.data;
    return res;
  }
}
